// extracted by mini-css-extract-plugin
export default {"products":"Lt-z","card":"Mt-z","oosMessaging":"Nt-z"};